const InfoFilledIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="inherit"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12Zm9.75-2.25v7.5h1.5v-7.5h-1.5Zm0-3v1.5h1.5v-1.5h-1.5Z"
        fillRule="evenodd"
      />
    </svg>

  );
};

export default InfoFilledIcon;
